import { LogMessage, useDebugLogs, useDebugLogsEnabled } from '@psyomics/ui-common';
import { Bug } from 'lucide-react';

import { Sheet, SheetContent, SheetTrigger } from '../../atoms/sheet/sheet';

const dateFormat = Intl.DateTimeFormat('en', {
  hour: '2-digit',
  hour12: false,
  minute: '2-digit',
  second: '2-digit',
});
const formatDate = (d: Date) => dateFormat.format(d);
const formatLogMessage = (msg: LogMessage): string =>
  `${formatDate(msg.timestamp)}: ${msg.msg}${msg.context ? ` [${JSON.stringify(msg.context)}]` : ``}`;

const preventDefault = (ev: Event) => ev.preventDefault();

export function DebugLogs() {
  const logs = useDebugLogs();
  const enabled = useDebugLogsEnabled();
  if (!enabled) return null;

  return (
    <Sheet modal={false}>
      <SheetTrigger asChild>
        <button
          aria-label={'Toggle debug logs'}
          className="fixed bottom-0 inline-flex items-center justify-center p-1 cursor-pointer opacity-70"
          type="button"
        >
          <Bug aria-hidden="true" className="h-4 w-4" />
        </button>
      </SheetTrigger>
      <SheetContent
        className="flex h-screen flex-col overflow-hidden [&>div.pl-6]:flex [&>div.pl-6]:flex-1 [&>div.pl-6]:min-h-0 [&>div.pl-6]:flex-col [&>div.pl-6]:overflow-hidden"
        onEscapeKeyDown={preventDefault}
        onInteractOutside={preventDefault}
        side={'right'}
        title={'Debug logs'}
      >
        <div className="flex min-h-0 flex-1 flex-col-reverse overflow-hidden">
          <div className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden whitespace-pre-wrap text-xs leading-4">
            {logs.map((msg, idx) => (
              <span className="block" key={`${idx}-${msg}`}>
                {formatLogMessage(msg)}
              </span>
            ))}
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
